import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import PagamentoIcon from "../../assets/icons/formapagto.png";
import FormasPagamentoService from "../../services/FormaPagtoService";

export default function FormasPagamentoForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idPagto: null,
    codPagto: "",
    descricao: "",
    taxa: "",
    observacao: "",
    ativo: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idPagto: null,
        codPagto: "",
        descricao: "",
        taxa: "",
        observacao: "",
        ativo: true,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idPagto: itemSelecionado.IDPAGTO,
        codPagto: itemSelecionado.COD_PAGTO,
        descricao: itemSelecionado.descricao,
        taxa: itemSelecionado.taxa,
        observacao: itemSelecionado.OBSERVACAO ?? "",
        ativo: itemSelecionado.ATIVO,
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.codPagto) e.codPagto = "Informe o código";
    if (!form.descricao) e.descricao = "Informe a descrição";

    return e;
  }

  function normalizarValor(valor) {
    if (valor === null || valor === "") return 0;
    return Number(String(valor).replace(/\./g, "").replace(",", "."));
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      const payload = {
        COD_PAGTO: form.codPagto,
        descricao: form.descricao,
        taxa: normalizarValor(form.taxa),
        OBSERVACAO: form.observacao,
        ATIVO: form.ativo
      };

      if (modo === "novo") {
        await FormasPagamentoService.create(payload);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Forma de pagamento criada com sucesso!",
        });
      }

      if (modo === "alterar") {
        await FormasPagamentoService.update(form.idPagto, payload);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Forma de pagamento atualizada com sucesso!",
        });
      }

      setSubmitState("SUCCESS");
      onClose();
    } catch (error) {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar forma de pagamento."
            : "Erro ao atualizar forma de pagamento.",
      });

      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={PagamentoIcon} alt="" className="icon" />
          {modo === "novo"
            ? "Cadastro de Forma de Pagamento"
            : "Alterar Forma de Pagamento"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Código *</div>
          <input
            name="codPagto"
            value={form.codPagto}
            onChange={handleChange}
          />
          {errors.codPagto && <span style={{ color: "red" }}>{errors.codPagto}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição *</div>
          <input
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
          />
          {errors.descricao && <span style={{ color: "red" }}>{errors.descricao}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Taxa (%)</div>
          <input
            name="taxa"
            value={form.taxa}
            onChange={handleChange}
            placeholder="0,00"
          />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Observação</div>
          <input
            name="observacao"
            value={form.observacao}
            onChange={handleChange}
          />
        </div>

        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
            <select
              name="ativo"
              value={String(form.ativo)}
              onChange={handleChange}
            >
              <option selected value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        )}

        <div className="Form-Interno-alinhamento-button">
          <button
            type="submit"
            disabled={loading}
            className="Form-Interno-button"
          >
            {loading ? "Enviando..." : "Salvar"}
          </button>
          
          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
